import StaffMemberInfo from './StaffMemberInfo.container';

export default StaffMemberInfo;
